export enum CrudType {
    CREATE,
    READ,
    SELECT,
    EDIT,
    DELETE
}
